import { BillInterval, PricingTier, ProductDescription } from "./product";
import { PaymentDetailsResponse, PaymentType } from "../payment/Payment";
import { EnterpriseAccountInfo } from "../types/CompanyInfo";
import { EnterpriseAccount, ProductName } from "./common";

export enum SubscriptionStatus {
  NOT_IN_USE_YET = "NOT_IN_USE_YET",
  CREATED_INACTIVE = "CREATED_INACTIVE",
  PAYMENT_REGISTERED = "PAYMENT_REGISTERED",
  ACTIVE = "ACTIVE",
}

export enum SubscriptionType {
  FREE = "FREE",
  PRO = "PRO",
  BASIC = "BASIC",
  SHAREHOLDER_REGISTER_LEGACY = "SHAREHOLDER_REGISTER_LEGACY",
}

export interface PaidSubscription {
  organisationNumber: string;
  subscriptionStatus: SubscriptionStatus;
  subscriptionType: SubscriptionType;
  isActive: boolean;
  allowsDbot?: boolean;
  allowsArchive?: boolean;
  allowsOrdinaryGeneralMeeting?: boolean;
  allowsMeeting?: boolean;
}

export type SubscriptionStatusContext = {
  subscriptionType?: SubscriptionType;
  currentPrice?: number;
  billInterval?: BillInterval;
  companyName: string;
  orgNo: string;
  email: string;
  name: string;
  productDescription?: ProductDescription;
  productName?: ProductName;
  tier?: PricingTier;
  paymentMethod?: PaymentType;
  paymentDetails?: PaymentDetailsResponse;
  enterpriseAccountInfo?: EnterpriseAccountInfo;
  availableEnterpriseAccounts: EnterpriseAccount[];
};
